import { calculateBoostedPotentialReturnBeforeTax, calculatePotentialReturn, calculateTotalPotentialReturn } from "~/utils/betslip/returns";
import { calculateTax, getTaxConf } from "~/utils/betslip/taxes";
import { calculateWinBoost } from "~/utils/betslip/winboost";
import { payoutLimitConfig } from "~/utils/betslip/limits";
import { IBetslipWinboost } from "~/types/betslip/betslip-winboost";
import { calculateActualWager } from "~/utils/betslip/wager";

export default (
	betsPreBoost: { priceNumerator: number; priceDenominator: number }[],
	bets: { priceNumerator: number; priceDenominator: number }[],
	wager: number,
	paymentType: 1 | 2 | 4,
	winboostConfig?: IBetslipWinboost | undefined
) => {
	const taxConfig = getTaxConf(paymentType);
	const actualWager = calculateActualWager(wager, paymentType);
	const payoutLimit = payoutLimitConfig(bets.length, paymentType);
	const potentialReturn = calculatePotentialReturn(bets, wager, paymentType);
	const winBoostTotal = calculateWinBoost(wager, potentialReturn, winboostConfig, paymentType, payoutLimit);
	const potentialReturnPreBoost = calculatePotentialReturn(betsPreBoost, wager, paymentType);
	const potentialReturnBeforeTaxPreBoost = calculateBoostedPotentialReturnBeforeTax(bets.length, potentialReturnPreBoost, 0, paymentType);
	const potentialReturnBeforeTax = calculateBoostedPotentialReturnBeforeTax(bets.length, potentialReturn, winBoostTotal, paymentType);
	const taxPreBoost = calculateTax(potentialReturnBeforeTaxPreBoost, wager, paymentType);
	const tax = calculateTax(potentialReturnBeforeTax, wager, paymentType);
	const totalPotentialReturnPreBoost = calculateTotalPotentialReturn(potentialReturnBeforeTaxPreBoost, taxPreBoost);
	const totalPotentialReturn = calculateTotalPotentialReturn(potentialReturnBeforeTax, tax, taxConfig.TaxZero ? taxConfig.TaxZero : false);
	const payoutAmount = potentialReturn + winBoostTotal - tax;

	return {
		actualWager,
		potentialReturnPreBoost,
		potentialReturn,
		potentialReturnBeforeTaxPreBoost,
		potentialReturnBeforeTax,
		taxPreBoost,
		tax,
		totalPotentialReturnPreBoost,
		totalPotentialReturn,
		winBoostTotal,
		payoutAmount,
	};
};
